import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    IsoAndUnixTimestamp} from "../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "../../date-time/iso-and-unix";
import { idZodSchema } from "../../id";
import type {
    MetaContent} from "../../meta-content/meta-content";
import {
    metaContentZodSchema,
} from "../../meta-content/meta-content";
import type { ProviderId} from "../../providers/provider-id";
import { providerIdZodSchema } from "../../providers/provider-id";

type PrinterAddCommand = {
    readonly _id: string;
    readonly _type: "PRINTER_ADD_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly meta: MetaContent;
};

type FactoryParams = Except<PrinterAddCommand, "_id" | "_type" | "_createdAt">;
const printerAddCommandFactory = (params: FactoryParams) => {
    const command: PrinterAddCommand = {
        ...params,
        _id: generateId({ prefix: "printer_add_command__" }),
        _type: "PRINTER_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const printerAddCommandIdZodSchema = idZodSchema.regex(
    /^printer_add_command__.*$/,
);
const printerAddCommandZodSchema: z.ZodSchema<PrinterAddCommand> = z.object({
    _id: printerAddCommandIdZodSchema,
    _type: z.literal("PRINTER_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    meta: metaContentZodSchema,
});

export { printerAddCommandFactory, printerAddCommandZodSchema };
export type {
    PrinterAddCommand,
    FactoryParams as PrinterAddCommandFactoryParams,
};
